import React, { useState, useEffect } from "react";
import AdminSidePanel from "./AdminSidePanel";
import { Link } from "react-router-dom";
import { AiOutlineExport } from "react-icons/ai";
import { FaPlusCircle } from "react-icons/fa";
import { useCookies } from "react-cookie";
import axios from "axios";

function AdminAgents() {
  const [cookies, removeCookie] = useCookies(["Authorization"]);
  const [userList, setUserList] = useState([]);
  const [agentList, setAgentList] = useState([]);

  useEffect(() => {
    axios.get("/api/user/load_list", { headers: cookies }).then((res) => {
      console.log("res.data for USERS in adminoverview is", res.data);
      setUserList(res.data.records);
    });
  }, []);

  useEffect(() => {
    axios.get("/api/user/agent_users", { headers: cookies }).then((res) => {
      console.log("res.data in adminagents is", res.data);
      setAgentList(res.data.records);
    });
  }, []);

  return (
    <>
      <main className="admin-panel">
        <div className="row">
          <div className="col-lg-2">
            <AdminSidePanel />
          </div>
          <div className="col-lg-9">
            <div className="admin-sitemap">
              Admin Panel {">"} Accounts {">"} Agents
            </div>
            <br></br>
            <br></br>
            {/* Agents */}
            <div className="col-lg-12">
              <div className="section-heading">
                <h2 className="sec__title font-size-24">Agents</h2>
                <Link to="/admin-addagent" className="admin-add">
                  <FaPlusCircle />
                </Link>
                <Link to="/admin-exportclients" className="admin-export">
                  Export <AiOutlineExport />
                </Link>
              </div>
              <div className="ledger-details-payment table-responsive">
                <table className="table mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Contact #</th>
                      <th scope="col">Recruited By</th>
                      <th scope="col">Position</th>
                      <th scope="col">Status</th>
                      <th scope="col">License</th>
                      <th scope="col">Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* update when agent list is available */}

                    {/* {agentList
                      .map((item) => (
                        <tr>
                          <td>{item.name}</td>
                          <td>Email</td>
                          <td>Contact #</td>
                          <td>Recruited By</td>
                          <td>Position</td>
                          <td>Status</td>
                          <td>License</td>
                          <td><Link to="/admin-agents">View</Link></td>
                        </tr>
                      ))} */}

                    {userList
                      .filter((item) => item.userType === "agent")
                      .map((item) => (
                        <tr>
                          <td>
                            {item.fname} {item.mnam} {item.lname}
                          </td>
                          <td>{item.email}</td>
                          <td>{item.contactNo}</td>
                          <td>{item.recruitedBy}</td>
                          <td>{item.position}</td>
                          <td>{item.status}</td>
                          <td>{item.license}</td>
                          <td>
                            <Link
                              to={{
                                pathname: "/admin-agents-view",
                                state: { details: item },
                              }}
                            >
                              View</Link>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <Link to="/admin-agents" className="admin-seeall">
                Page 1 of 1 Next {">>"}
              </Link>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
          </div>
        </div>
      </main>
    </>
  );
}

export default AdminAgents;
